/* eslint-disable no-unused-expressions */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/no-array-index-key */

import React, { Component } from 'react';
import { Card, CardDeck, CardBody, Col, Button } from 'reactstrap';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import axios from 'axios';

const isEquals = require('lodash.isequal');

const URL = 'https://api.musicmarquee.co.uk';

const clone = value => JSON.parse(JSON.stringify(value));

const formatMoney = (value) => {
  if (value === null || value === undefined || value === '') {
    return '-';
  }

  return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(value);
};

class ShopifyStockTable extends Component {
  constructor() {
    super();
    this.state = {
      pages: 0,
      loading: false,
      data: [],
      selected: undefined,
      selectedOriginal: undefined,
      isEditing: false,
      saveError: '',
    };

    this.handleProductChange = this.handleProductChange.bind(this);
    this.saveProduct = this.saveProduct.bind(this);
  }

  handleProductChange(e) {
    const selected = { ...this.state.selected };
    selected[e.target.name] = e.target.value;
    this.setState({ selected, saveError: '' });
  }

  async saveProduct() {
    try {
      const response = await axios.post(`${URL}/admin/fulfillment/shopify/stock/update`, {
        product: this.state.selected,
      }, {
        headers: {
          Authorization: localStorage.getItem('mm_admin'),
        },
      });

      if (response.data.error) {
        this.setState({ saveError: response.data.error.message || 'Unable to save product.' });
        return;
      }

      const { product } = response.data;
      const data = this.state.data.map(item => (item.id === product.id ? product : item));

      this.setState({
        selected: clone(product),
        selectedOriginal: clone(product),
        data,
        isEditing: false,
        saveError: '',
      });
    } catch (error) {
      this.setState({ saveError: 'Unable to save product.' });
    }
  }

  renderDetailPanel() {
    const { selected, selectedOriginal, isEditing } = this.state;

    if (!selected) {
      return null;
    }

    return (
      <CardDeck>
        <Card>
          <CardBody>
            <Button
              color="primary"
              size="sm"
              disabled={isEditing}
              onClick={() => this.setState({ isEditing: true })}
            >
              Edit
            </Button>
            {isEditing ? (
              <Button
                color="danger"
                size="sm"
                style={{ marginLeft: 6 }}
                onClick={() => this.setState({
                  isEditing: false,
                  selected: clone(selectedOriginal),
                  saveError: '',
                })}
              >
                Cancel
              </Button>
            ) : null}
            {this.state.saveError ? (
              <span style={{ color: 'red', marginLeft: 10 }}>{this.state.saveError}</span>
            ) : null}

            <div className="project-summary" style={{ marginTop: 15 }}>
              <div className="project-summary__stats">
                <div className="project-summary__stat">
                  <table className="project-summary__info">
                    <tbody>
                      <tr>
                        <th>Product ID:</th>
                        <td>{selected.id}</td>
                      </tr>
                      <tr>
                        <th>Client:</th>
                        <td>{selected.client_name || selected.client_id || '-'}</td>
                      </tr>
                      <tr>
                        <th>Store:</th>
                        <td>{selected.shop_name || '-'}</td>
                      </tr>
                      <tr>
                        <th>Title:</th>
                        <td>{selected.title}</td>
                      </tr>
                      <tr>
                        <th>Vendor:</th>
                        <td>{selected.vendor}</td>
                      </tr>
                      <tr>
                        <th>Type:</th>
                        <td>{selected.product_type}</td>
                      </tr>
                      <tr>
                        <th>Status:</th>
                        <td>{selected.status}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div className="project-summary__stat">
                  <table className="project-summary__info">
                    <tbody>
                      <tr>
                        <th>HS Code:</th>
                        <td>
                          {isEditing ? (
                            <input
                              type="text"
                              name="hs_code"
                              value={selected.hs_code || ''}
                              onChange={this.handleProductChange}
                            />
                          ) : selected.hs_code}
                        </td>
                      </tr>
                      <tr>
                        <th>Customs Desc:</th>
                        <td>
                          {isEditing ? (
                            <input
                              type="text"
                              name="customs_desc"
                              value={selected.customs_desc || ''}
                              onChange={this.handleProductChange}
                            />
                          ) : selected.customs_desc}
                        </td>
                      </tr>
                      <tr>
                        <th>Origin:</th>
                        <td>
                          {isEditing ? (
                            <input
                              type="text"
                              name="customs_origin"
                              value={selected.customs_origin || ''}
                              onChange={this.handleProductChange}
                            />
                          ) : selected.customs_origin}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {(selected.variants || []).length > 0 ? (
              <div style={{ marginTop: 20 }}>
                <table className="table table-sm">
                  <thead>
                    <tr>
                      <th>Variant</th>
                      <th>SKU</th>
                      <th>Price</th>
                      <th>Weight (g)</th>
                      <th>Inventory</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selected.variants.map((variant, index) => (
                      <tr key={variant.id || index}>
                        <td>{variant.title}</td>
                        <td>{variant.sku}</td>
                        <td>{formatMoney(variant.price)}</td>
                        <td>{variant.grams}</td>
                        <td>{variant.inventory_quantity}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : null}

            {isEquals(selectedOriginal, selected) ? null : (
              <Button color="primary" size="sm" onClick={this.saveProduct}>
                Save Changes
              </Button>
            )}
          </CardBody>
        </Card>
      </CardDeck>
    );
  }

  render() {
    const columns = [
      {
        Header: 'Client',
        id: 'client_name',
        accessor: 'client_name',
      },
      {
        Header: 'Store',
        id: 'shop_name',
        accessor: 'shop_name',
      },
      {
        Header: 'Title',
        id: 'title',
        accessor: 'title',
      },
      {
        Header: 'Vendor',
        id: 'vendor',
        accessor: 'vendor',
      },
      {
        Header: 'Type',
        id: 'product_type',
        accessor: 'product_type',
      },
      {
        Header: 'Status',
        id: 'status',
        accessor: 'status',
        width: 100,
      },
      {
        Header: 'SKU',
        id: 'sku',
        accessor: item => (item.variants || []).map(variant => variant.sku).filter(Boolean).join(', '),
      },
      {
        Header: 'HS Code',
        id: 'hs_code',
        accessor: 'hs_code',
        width: 120,
      },
      {
        Header: 'Customs Desc',
        id: 'customs_desc',
        accessor: 'customs_desc',
      },
      {
        Header: 'Origin',
        id: 'customs_origin',
        accessor: 'customs_origin',
        width: 100,
      },
    ];

    return (
      <Col>
        <Card style={{ height: '550px' }}>
          <CardBody>
            <ReactTable
              style={{ height: '470px' }}
              data={this.state.data}
              columns={columns}
              pages={this.state.pages}
              loading={this.state.loading}
              manual
              filterable
              multiSort={false}
              defaultPageSize={50}
              className="-striped -highlight -responsive"
              getTrProps={(state, rowInfo) => {
                if (rowInfo !== undefined) {
                  return {
                    onClick: () => {
                      this.setState({
                        selected: clone(rowInfo.original),
                        selectedOriginal: clone(rowInfo.original),
                        isEditing: false,
                        saveError: '',
                      });
                    },
                    style: {
                      background: rowInfo.original.id === (this.state.selected && this.state.selected.id) ?
                        '#00afec' : 'white',
                      color: rowInfo.original.id === (this.state.selected && this.state.selected.id) ?
                        'white' : 'black',
                    },
                  };
                }
                return {};
              }}
              onFetchData={(state) => {
                this.setState({ loading: true });
                axios.post(`${URL}/admin/fulfillment/shopify/stock`, {
                  page: state.page,
                  pageSize: state.pageSize,
                  sorted: state.sorted,
                  filtered: state.filtered,
                }, {
                  headers: {
                    Authorization: localStorage.getItem('mm_admin'),
                  },
                })
                  .then((res) => {
                    this.setState({
                      data: res.data.items || [],
                      pages: res.data.pages || 0,
                      loading: false,
                    });
                  })
                  .catch(() => {
                    this.setState({
                      data: [],
                      pages: 0,
                      loading: false,
                    });
                  });
              }}
            />
          </CardBody>
        </Card>
        {this.renderDetailPanel()}
      </Col>
    );
  }
}

export default ShopifyStockTable;
